import { useDashboardStore } from 'src/stores/index.js'
import WidgetsService from 'src/services/widgets'
import DashboardService from 'src/services/dashboard'
import Widget from 'src/models/Widget.model'

export default {
  fetchPaginated () {
    const promise = WidgetsService.fetchPaginated()

    promise.then(result => {
      this.widgets = result.data.map(widget => new Widget(widget))
    })

    return promise
  },
  fetchFromDashboard (id) {
    const promise = DashboardService.fetchWidgets(id)

    promise.then(result => {
      this.widgets = result.data.map(widget => new Widget(widget))
    })

    return promise
  },
  fetchDefaultDashboard () {
    const promise = WidgetsService.fetchDefaultWidgets()

    promise.then(result => {
      this.widgets = result.data.map(widget => new Widget(widget))
    })

    return promise
  },
  delete (id) {
    const promise = WidgetsService.delete(id)

    promise.then(() => {
      this.widgets = this.widgets.filter(widgets => widgets.id !== id)
    })

    return promise
  },
  create (payload) {
    const promise = WidgetsService.create(payload)

    promise.then(widget => {
      this.widgets.push(widget)
    })

    return promise
  },
  clearAll () {
    useDashboardStore().setSelectedDashboard(null)
    this.widgets = []
  },
  update (payload) {
    const promise = WidgetsService.update(payload)

    promise.then(result => {
      this.widgets = this.widgets.map(current => {
        return current.id === result.id ? result : current
      })
    })

    return promise
  },
  movedWidgets () {
    const widgets = this.widgets.map((widget, index) => {
      widget.order = index
      return widget
    })
    const updating = widgets.map(widget => WidgetsService.update(widget))
    return Promise.all(updating)
  }
}
